/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { AuditLogDto } from '../models/audit-log-dto';
import { auditLogsPost$Json } from '../fn/audit/audit-logs-post-json';
import { AuditLogsPost$Json$Params } from '../fn/audit/audit-logs-post-json';
import { auditLogsPost$Plain } from '../fn/audit/audit-logs-post-plain';
import { AuditLogsPost$Plain$Params } from '../fn/audit/audit-logs-post-plain';

@Injectable({ providedIn: 'root' })
export class AuditApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `auditLogsPost()` */
  static readonly AuditLogsPostPath = '/audit/logs';

  /**
   * Query audit logs.
   *
   * Returns audit logs for the current organization using a filter.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `auditLogsPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  auditLogsPost$Plain$Response(params?: AuditLogsPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AuditLogDto>>> {
    const obs = auditLogsPost$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Query audit logs.
   *
   * Returns audit logs for the current organization using a filter.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `auditLogsPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  auditLogsPost$Plain(params?: AuditLogsPost$Plain$Params, context?: HttpContext): Observable<Array<AuditLogDto>> {
    const resp = this.auditLogsPost$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<AuditLogDto>>): Array<AuditLogDto> => r.body)
    );
  }

  /**
   * Query audit logs.
   *
   * Returns audit logs for the current organization using a filter.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `auditLogsPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  auditLogsPost$Json$Response(params?: AuditLogsPost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AuditLogDto>>> {
    const obs = auditLogsPost$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Query audit logs.
   *
   * Returns audit logs for the current organization using a filter.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `auditLogsPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  auditLogsPost$Json(params?: AuditLogsPost$Json$Params, context?: HttpContext): Observable<Array<AuditLogDto>> {
    const resp = this.auditLogsPost$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<AuditLogDto>>): Array<AuditLogDto> => r.body)
    );
  }

}
